(function () {
  // ===============================
  // Helpers: normalize keys
  // ===============================
  const cleanColor = (v) =>
    String(v || "")
      .replace(/^#\s*\d+\s*/i, "") // removes "#1 " or "# 1 "
      .trim();

  const normalizeKey = (v) =>
    String(v || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();

  function extractKey(rawValue) {
    const raw = String(rawValue || "");
    const part = raw.includes("|")
      ? raw.split("|")[0]
      : raw.includes(" - ")
      ? raw.split(" - ")[0]
      : raw;

    return normalizeKey(cleanColor(part));
  }

  // ===============================
  // Read currently selected Color option
  // ===============================
  function getSelectedColor(productInfoEl) {
    const vs = productInfoEl.querySelector("variant-selects");
    if (!vs) return null;

    const optionNameWanted = "color";

    // Fieldset (swatches / buttons)
    const fieldsets = Array.from(vs.querySelectorAll("fieldset"));
    for (const fs of fieldsets) {
      const legend = fs.querySelector("legend");
      const legendText = (legend?.textContent || "").trim().toLowerCase();

      if (legendText.startsWith(optionNameWanted)) {
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (checked?.value) return checked.value;

        const shown = fs.querySelector("[data-selected-value]");
        if (shown?.textContent) return shown.textContent.trim();

        return null;
      }
    }

    // Dropdown option (select)
    const dropdowns = Array.from(vs.querySelectorAll(".product-form__input--dropdown"));
    for (const dd of dropdowns) {
      const label = dd.querySelector("label");
      const labelText = (label?.textContent || "").trim().toLowerCase();

      if (labelText === optionNameWanted) {
        const select = dd.querySelector('select[name^="options["]');
        if (select?.value) return select.value;

        const shown = dd.querySelector("[data-selected-value]");
        if (shown?.textContent) return shown.textContent.trim();

        return null;
      }
    }

    // Fallback
    const shown = vs.querySelector("[data-selected-value]");
    if (shown?.textContent) return shown.textContent.trim();

    return null;
  }

  // ===============================
  // Variant / Inventory sync (your Step 2)
  // ===============================
  function getKlixVariantData(productInfoEl) {
    const sectionId = productInfoEl.getAttribute("data-section");
    if (!sectionId) return null;

    const jsonEl = document.getElementById(`KlixVariantInventory-${sectionId}`);
    if (!jsonEl) return null;

    try {
      return JSON.parse(jsonEl.textContent || "[]");
    } catch {
      return null;
    }
  }

  function getKlixSelectedOptions(productInfoEl) {
    const vs = productInfoEl.querySelector("variant-selects");
    if (!vs) return [];

    const selects = Array.from(vs.querySelectorAll('select[name^="options["]'));
    if (selects.length) return selects.map((s) => s.value);

    return Array.from(vs.querySelectorAll("fieldset"))
      .map((fs) => fs.querySelector('input[type="radio"]:checked')?.value)
      .filter(Boolean);
  }

  function setKlixShopifyVariant(productInfoEl) {
    const variants = getKlixVariantData(productInfoEl);
    if (!variants) return;

    const selectedOptions = getKlixSelectedOptions(productInfoEl);
    if (!selectedOptions.length) return;

    const match = variants.find(
      (v) =>
        Array.isArray(v.options) &&
        v.options.length === selectedOptions.length &&
        v.options.every((opt, i) => String(opt) === String(selectedOptions[i]))
    );

    if (!match?.id) return;

    const form = productInfoEl.querySelector('form[action*="/cart/add"]');
    const idInput = form?.querySelector('input[name="id"]');
    if (!idInput) return;

    idInput.value = match.id;
    idInput.setAttribute("value", match.id);

    idInput.dispatchEvent(new Event("input", { bubbles: true }));
    idInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  // ===============================
  // Gallery DOM helpers
  // ===============================
  function getGallery(productInfoEl) {
    return productInfoEl.querySelector("media-gallery");
  }

  function getThumbRoot(productInfoEl) {
    const gallery = getGallery(productInfoEl);
    if (!gallery) return null;

    return (
      gallery.querySelector("#Slider-Thumbnails-" + CSS.escape(productInfoEl.closest("section")?.id || "")) ||
      gallery.querySelector('[id*="Slider-Thumbnails-"]') ||
      gallery.querySelector('[id*="Thumbnails"]') ||
      gallery.querySelector('[id*="GalleryThumbnails"]') ||
      gallery.querySelector(".thumbnail-list") ||
      gallery.querySelector("ul.thumbnail-list") ||
      gallery.querySelector("slider-component[id*='Thumbnails']") ||
      gallery.querySelector("[data-thumbnails]") ||
      null
    );
  }

  function getThumbLis(productInfoEl) {
    const root = getThumbRoot(productInfoEl);
    if (!root) return [];

    const lis = Array.from(root.querySelectorAll("li"));
    return lis.filter((li) => {
      if (li.hasAttribute("data-target")) return true;
      const btn = li.querySelector("button, a");
      if (!btn) return false;
      return btn.hasAttribute("aria-controls") || btn.hasAttribute("data-target");
    });
  }

  function getSlides(productInfoEl) {
    const gallery = getGallery(productInfoEl);
    if (!gallery) return [];
    // Main slides are li[data-media-id]
    return Array.from(gallery.querySelectorAll('li[data-media-id]'));
  }

  function getThumbTarget(li) {
    const btn = li.querySelector("button, a");
    return (
      li.getAttribute("data-target") ||
      btn?.getAttribute("data-target") ||
      btn?.getAttribute("aria-controls") ||
      null
    );
  }

  function setDisplay(el, show) {
    el.style.display = show ? "" : "none";
    el.setAttribute("aria-hidden", show ? "false" : "true");
  }

  // Dawn API (if available)
function buildTargetIdFromMediaId(productInfoEl, mediaId) {
  if (!mediaId) return null;

  const slides = getSlides(productInfoEl);
  const any = slides[0]?.getAttribute("data-media-id");
  if (!any) return null;

  // data-media-id looks like: "{{ section.id }}-{{ media.id }}"
  const prefix = String(any).split("-")[0];
  return `${prefix}-${mediaId}`;
}


  function setActiveViaMediaGalleryAPI(productInfoEl, targetId) {
    const gallery = getGallery(productInfoEl);
    if (!gallery || !targetId) return false;

    if (typeof gallery.setActiveMedia === "function") {
      gallery.setActiveMedia(targetId, true);
      return true;
    }
    if (typeof gallery.setActiveThumbnail === "function") {
      gallery.setActiveThumbnail(targetId, true);
      return true;
    }
    return false;
  }

  // ===============================
  // Core: apply filtering for selected color
  // ===============================
  function apply(productInfoEl) {
  // Keep inventory sync running (critical)
  setKlixShopifyVariant(productInfoEl);

  const selected = getSelectedColor(productInfoEl);
  if (!selected) return;

  const wanted = normalizeKey(cleanColor(selected));

  const thumbs = getThumbLis(productInfoEl);
  const slides = getSlides(productInfoEl);
  if (!thumbs.length || !slides.length) return;

  // 1) Find matching thumbs (by klix key OR thumb img alt OR button aria-label)
  const matchingThumbs = thumbs.filter((li) => {
    const dk = li.getAttribute("data-klix-color-key");
    if (dk && extractKey(dk) === wanted) return true;

    const alt = li.querySelector("img")?.getAttribute("alt");
    if (alt && extractKey(alt) === wanted) return true;

    const btn = li.querySelector("button, a");
    const aria = btn?.getAttribute("aria-label");
    if (aria && extractKey(aria) === wanted) return true;

    return false;
  });

  // If no matches, bail safely (do NOT hide everything)
  if (!matchingThumbs.length) return;

  // 2) Allowed targets from matching thumbs
  const allowedTargets = new Set(
    matchingThumbs
      .map(getThumbTarget)
      .filter(Boolean)
      .map(String)
  );

  if (!allowedTargets.size) return;

  // 3) Show ONLY matching thumbs
  thumbs.forEach((li) => {
    const t = String(getThumbTarget(li) || "");
    setDisplay(li, allowedTargets.has(t));
  });

  // 4) Show ONLY slides that are allowed
  slides.forEach((li) => {
    const mediaId = String(li.getAttribute("data-media-id") || "");
    setDisplay(li, allowedTargets.has(mediaId));
  });

  // 5) FORCE featured media immediately (this is the speed fix)
  // Prefer variant's featured_media if we have it; otherwise first allowed
  const v = productInfoEl.__klixLastVariant || null;
  const featuredMediaId = v?.featured_media?.id || null;

  let targetToActivate = null;

  if (featuredMediaId) {
    const built = buildTargetIdFromMediaId(productInfoEl, featuredMediaId);
    if (built && allowedTargets.has(String(built))) {
      targetToActivate = String(built);
    }
  }

  if (!targetToActivate) {
    targetToActivate = Array.from(allowedTargets)[0];
  }

  // Activate via Dawn API first (fast), else click matching thumb
  if (!setActiveViaMediaGalleryAPI(productInfoEl, targetToActivate)) {
    const thumb = matchingThumbs.find((li) => String(getThumbTarget(li)) === targetToActivate) || matchingThumbs[0];
    const btn = thumb?.querySelector("button, a");
    btn?.click?.();
  }
}
function apply(productInfoEl) {
    // Keep inventory sync running
    setKlixShopifyVariant(productInfoEl);

    const selected = getSelectedColor(productInfoEl);
    if (!selected) return;

    const wanted = normalizeKey(cleanColor(selected));

    const thumbs = getThumbLis(productInfoEl);
    const slides = getSlides(productInfoEl);
    if (!thumbs.length || !slides.length) return;

    // 1) Find matching thumbs (by klix key OR thumb img alt OR button aria-label)
    const matchingThumbs = thumbs.filter((li) => {
      const dk = li.getAttribute("data-klix-color-key");
      if (dk && extractKey(dk) === wanted) return true;

      const alt = li.querySelector("img")?.getAttribute("alt");
      if (alt && extractKey(alt) === wanted) return true;

      const btn = li.querySelector("button, a");
      const aria = btn?.getAttribute("aria-label");
      if (aria && extractKey(aria) === wanted) return true;

      return false;
    });

    if (!matchingThumbs.length) {
      // If no matches, do NOT hide everything. Just bail safely.
      return;
    }

    // 2) Build allowed target IDs from matching thumbs
    const allowedTargets = new Set(
      matchingThumbs
        .map(getThumbTarget)
        .filter(Boolean)
        .map(String)
    );

    if (!allowedTargets.size) return;

    // 3) Show ONLY matching thumbs
    thumbs.forEach((li) => setDisplay(li, allowedTargets.has(String(getThumbTarget(li)))));

    // 4) Show ONLY slides whose data-media-id is allowed target
    slides.forEach((li) => {
      const mediaId = String(li.getAttribute("data-media-id") || "");
      setDisplay(li, allowedTargets.has(mediaId));
    });

    // 5) Ensure an allowed slide is active
    // If current active slide is hidden, force first allowed target active
    const activeSlide =
      slides.find((s) => s.classList.contains("is-active")) ||
      slides.find((s) => s.getAttribute("aria-current") === "true");

    const activeId = activeSlide?.getAttribute("data-media-id");

    const firstAllowed = Array.from(allowedTargets)[0];

    // If active isn't allowed, activate first allowed
    if (!activeId || !allowedTargets.has(String(activeId))) {
      // Try Dawn API first
      if (!setActiveViaMediaGalleryAPI(productInfoEl, firstAllowed)) {
        // Fallback: click the first visible thumb (works for videos)
        const firstThumb = matchingThumbs[0];
        const btn = firstThumb?.querySelector("button, a");
        btn?.click?.();
      }
    }
  }

  // ===============================
  // Robust re-apply (fixes “works for 2 then freezes”)
  // - Dawn often re-renders thumbnail list / slides after change
  // ===============================
  function debounce(fn, wait) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, arguments), wait);
    };
  }

  function observeGallery(productInfoEl) {
    if (productInfoEl.__klixObserverBound) return;
    productInfoEl.__klixObserverBound = true;

    const gallery = getGallery(productInfoEl);
    if (!gallery) return;

    const rerun = debounce(() => apply(productInfoEl), 10);

    const mo = new MutationObserver(() => {
      // Any time Dawn mutates the gallery, re-apply our filtering
      rerun();
    });

    mo.observe(gallery, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style", "aria-hidden", "aria-current", "data-media-id", "data-target"],
    });

    productInfoEl.__klixMO = mo;
  }

  // ===============================
  // Init + listeners
  // ===============================
  function init(productInfoEl) {
  if (!productInfoEl || productInfoEl.__klixInitDone) return;
  productInfoEl.__klixInitDone = true;

  observeGallery(productInfoEl);

  // Apply immediately (faster featured swap), then once more next frame
  apply(productInfoEl);
  requestAnimationFrame(() => apply(productInfoEl));

  const variantSelects = productInfoEl.querySelector("variant-selects");
  if (!variantSelects) return;

  // Fast immediate run + a short debounced follow-up (handles Dawn re-render)
  const runDebounced = debounce(() => apply(productInfoEl), 15);
  const runNow = () => {
    apply(productInfoEl);
    runDebounced();
  };

  variantSelects.addEventListener("change", runNow);
  variantSelects.addEventListener("click", runNow);

  // Dawn emits variant:change on product-info
  productInfoEl.addEventListener("variant:change", (e) => {
  productInfoEl.__klixLastVariant = e?.detail?.variant || null;
  runNow();
});

}


  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("product-info").forEach(init);
  });

  document.addEventListener("shopify:section:load", (e) => {
    e.target?.querySelectorAll?.("product-info")?.forEach(init);
  });
})();
